import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const VideoContentPanelStyle: SxStyles = {
  videoTabContainer: {
    margin: 'auto',
    width: '90%',
    mb: getResponsiveSize(6),
    pr: getResponsiveSize(10),
    '& .css-19kzrtu': {
      p: 0,
    },
    '& .tabs-container': {
      zIndex: -2,
      overflowY: 'hidden',

      '& .tabs': {
        backgroundColor: theme.palette.mainControls?.inActivegrey,
        borderRadius: '20px',
        pb: 0.3,
        pt: 0.3,
        pl: 0.5,
        pr: 0.5,
        minHeight: 0,
        '& .tab': {
          zIndex: 3,
          fontSize: getResponsiveSize(12),
          color: '#a1a1a1',
          width: '50%',
          minHeight: 0,
          textTransform: 'unset',
          fontFamily: theme.typography.fontFamily,
          maxWidth: 'unset',
          '&.Mui-selected': {
            color: '#7B7B7B',
            '& .icon': {
              fill: '#7B7B7B',
            },
          },

          '& .span': {
            padding: 0,
            height: getResponsiveSize(10),
          },
          '& .icon': {
            fill: '#a1a1a1',
            height: getResponsiveSize(18),
            width: getResponsiveSize(18),
            zIndex: 2,
          },
        },
        '& .MuiTabs-indicator': {
          backgroundColor: '#FCFCFC',
          height: '95%',
          zIndex: 1,
          borderRadius: '20px',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
        },
      },
    },
  },
};
